import { clearWarehousesList } from 'containers/Warehouses/warehousesSlice'
import { fetchLogOut } from 'containers/Login/loginSlice'
import { useReduxDispatch } from 'store'

const useLogout = () => {
  const dispatch = useReduxDispatch()
  const action = () => {
    dispatch(fetchLogOut()).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        dispatch(clearWarehousesList())
      }
    })
  }

  return action
}

export default useLogout